import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Translate } from 'i18n'
import AppCaptcha from 'components/AppCaptcha'
import FormEmailFooter from 'themes/bonial/components/FormEmailFooter'
import './style.css'


export default class FormFooter extends Component {
    static propTypes = {
        isEmailSent: PropTypes.bool,
        isDisabled: PropTypes.bool.isRequired,
        isCaptchaEnabled: PropTypes.bool,
        onSave: PropTypes.func.isRequired,
        onSendMail: PropTypes.func
    }

    static defaultProps = {
        isCaptchaEnabled: false,
        onSendMail: null
    }

    constructor(props) {
        super(props)

        this.state = {
            isEmailView: false
        }
    }

    onEmailClickHandler() {
        this.setState({
            isEmailView: true
        })
    }

    handleCancelClick = () => {
        this.setState({
            isEmailView: false
        })
    }

    handleSubmitClick = () => {
        this.setState({
            isEmailView: false
        })
    }

    render() {
        if (this.state.isEmailView) {
            return <FormEmailFooter onCancel={this.handleCancelClick} onSubmit={this.handleSubmitClick } />
        }



        return (
            <div className='form-footer'>
                { this.props.isCaptchaEnabled && <AppCaptcha /> }

                <div className='controls-container'>
                    <span
                        onClick={() => this.onEmailClickHandler()}
                        className={`button button_type_secondary button_icon_${!this.props.isEmailSent || this.props.isDisabled ? 'send' : 'check'} ${this.props.isDisabled || this.props.isEmailSent ? 'button_type_disabled' : ''}`}>

                        <span className={`icon icon-${!this.props.isEmailSent || this.props.isDisabled ? 'send' : 'check'}`} />

                        { !this.props.isEmailSent || this.props.isDisabled
                            ? <Translate value='emailMeTheList' />
                            : <Translate value='emailSent' />
                        }
                    </span>

                    <button
                        onClick={this.props.onSave}
                        className={`button button_icon_arrow button_type_alert ${this.props.isDisabled ? 'button_type_disabled' : ''}`}>
                        <Translate value='saveShoppingList' />
                        <span className='icon icon-arrow'></span>
                    </button>
                </div>
            </div>
        )
    }

}
